import { ShieldCheck } from "lucide-react";
import {
  OPERATOR_TRUTH_RULES,
  OUT_OF_SCOPE,
  SUPPORTED_FRAMEWORKS,
  SUPPORTED_LANGUAGES,
  SUPPORTED_SCOPE_ID,
  SUPPORTED_SCOPE_SUMMARY,
} from "../lib/supported-scope.js";

export function SupportedScopePanel({ variant = "full" }: { variant?: "compact" | "full" }) {
  if (variant === "compact") {
    return (
      <section
        className="supported-scope supported-scope--compact"
        aria-label="Supported static proof-of-concept scope"
        data-testid="supported-scope"
      >
        <ShieldCheck aria-hidden="true" size={16} />
        <p>
          <strong>Static PoC scope.</strong> Results are evidence-bound; unsupported surfaces stay
          explicit. <a href="/help#supported-scope-heading">Read truth rules</a>
        </p>
      </section>
    );
  }
  return (
    <section
      className={`supported-scope supported-scope--${variant}`}
      aria-labelledby="supported-scope-heading"
      data-testid="supported-scope"
    >
      <div className="supported-scope__heading">
        <ShieldCheck aria-hidden="true" size={16} />
        <div>
          <span className="page-kicker">What this console actually covers</span>
          <h2 id="supported-scope-heading">Supported scope</h2>
        </div>
      </div>
      <p>{SUPPORTED_SCOPE_SUMMARY}</p>
      <>
        <h3>Languages and parsers</h3>
        <ul className="supported-scope__list">
          {SUPPORTED_LANGUAGES.map((language) => (
            <li key={language.id}>
              <strong>
                {language.id} · <code>{language.parser}</code>
              </strong>
              <span>{language.note}</span>
            </li>
          ))}
        </ul>
        <h3>Web frameworks in scope</h3>
        <p>{SUPPORTED_FRAMEWORKS.join(", ")}.</p>
        <h3>How to read a result</h3>
        <dl>
          {OPERATOR_TRUTH_RULES.map((rule) => (
            <div key={rule.id}>
              <dt>{rule.title}</dt>
              <dd>{rule.body}</dd>
            </div>
          ))}
        </dl>
        <h3>Not in this candidate</h3>
        <ul>
          {OUT_OF_SCOPE.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className="supported-scope__id">
          Contract <code>{SUPPORTED_SCOPE_ID}</code>
        </p>
      </>
    </section>
  );
}
